<template>
  <div class="flex gap-100 justify-between items-center">
    <slot />
    <span
      class="paragraph-small-text bg-secondary-secondary-disabled text-secondary-secondary rounded-xs px-025"
    >
      {{ $t('account.payout.aeropay.tag') }}
    </span>
  </div>
</template>
